// extracted by mini-css-extract-plugin
module.exports = {"SeeMoreButton":"NewsPosts_SeeMoreButton__2j3UV","InformationCardColumn":"NewsPosts_InformationCardColumn__27vMf"};